import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <section id="faq" className="bg-slate-50">
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="text-center mb-12">
          <div className="flex items-baseline justify-center gap-3">
            <span className="font-display font-black text-sm text-[#A88852]">06 —</span>
            <div className="label-eyebrow">FAQ</div>
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-2 text-slate-900">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-slate-200 rounded-md px-5"
            >
              <AccordionTrigger className="text-left font-display font-bold text-slate-900 text-base md:text-lg hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-base leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
